import React from "react";
import AfriMedDialog from "@/sot/primitives/AfriMedDialog.jsx";

export default function LocationConsentDialog({
  open,
  onClose,
  onAllowOnce,
  onAllowAlways,
  onDeny,
}) {
  return (
    <AfriMedDialog
      open={open}
      onClose={onClose}
      title="Enable location access?"
      subtitle="For the best nearby healthcare results and live directions, allow access to your current location. You can allow once, always allow, or enable location later in your browser settings."
      footer={
        <div className="px-5 pb-5 pt-2">
          <div className="grid gap-3">
            <button
              type="button"
              onClick={onAllowOnce}
              className="w-full px-5 py-3 rounded-xl text-label-large"
              style={{
                background: "var(--state-primary-12)",
                color: "var(--on-primary)",
              }}
            >
              Allow once
            </button>

            <button
              type="button"
              onClick={onAllowAlways}
              className="w-full px-5 py-3 rounded-xl text-label-large border"
              style={{
                borderColor: "rgba(24,50,119,0.18)",
                background: "transparent",
                color: "var(--on-surface)",
              }}
            >
              Always allow
            </button>

            <button
              type="button"
              onClick={onDeny}
              className="w-full px-5 py-3 rounded-xl text-label-large"
              style={{
                background: "rgba(24,50,119,0.06)",
                color: "var(--on-surface)",
              }}
            >
              Deny
            </button>
          </div>
        </div>
      }
    >
      {/* No extra body content needed. Keeping it calm + clean. */}
      <div className="px-5 pb-2" />
    </AfriMedDialog>
  );
}
